import React from 'react';
import {Alert, Box, Divider, List, ListItem, Skeleton, Typography} from '@mui/material';
import {alpha} from '@mui/material/styles';
import DashboardPaper from './DashboardPaper';
import MetricSelect from './MetricSelect';
import {dashboardMetrics, formatMetric} from './dashboardMetrics';

export default function OverviewTable({data, title, metric, onMetricChange, currencyCode, error}) {
    const selectedMetric = dashboardMetrics.find(item => item.key === metric);
    const maximum = Math.max(1, ...(data || []).map(item => Math.abs(Number(item[metric]) || 0)));
    return (
        <DashboardPaper sx={{minWidth: 0, backgroundColor: 'background.darkBlue'}}>
            <Box sx={{p: 2.5, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
                <Box>
                    <Typography component="h2" sx={{fontSize: 16, fontWeight: 600}}>{title}</Typography>
                    <Typography sx={{mt: 0.5, fontSize: 12, color: 'text.secondary'}}>Top 5 by {selectedMetric.label.toLowerCase()}</Typography>
                </Box>
                <MetricSelect label="Rank by" value={metric} onChange={onMetricChange}/>
            </Box>
            <Divider/>
            {error ? <Alert severity="error" sx={{m: 2}}>{error}</Alert> : data == null ?
                <Box role="status" aria-label={`Loading ${title}`} sx={{p: 2.5}}>
                    {[0, 1, 2, 3, 4].map(index => <Skeleton key={index} height={47}/>)}
                </Box> : !data.length ?
                    <Box sx={{p: 5, textAlign: 'center', color: 'text.secondary', fontSize: 14}}>No results for this period</Box> :
                    <List disablePadding sx={{px: 2.5, py: 0.5}}>
                        {data.map((item, index) => (
                            <ListItem key={item.id || index} disableGutters divider={index !== data.length - 1} sx={{py: 1.5, gap: 1.5}}>
                                <Box sx={{width: 28, height: 28, flexShrink: 0, display: 'grid', placeItems: 'center',
                                    borderRadius: '8px', bgcolor: 'background.input', color: 'text.secondary', fontSize: 12, fontWeight: 600}}>{index + 1}</Box>
                                <Box sx={{flex: 1, minWidth: 0}}>
                                    <Typography title={item.name} noWrap sx={{fontSize: 13, fontWeight: 500}}>{item.name || 'Unnamed'}</Typography>
                                    <Box sx={{mt: 0.75, width: '100%', maxWidth: 180, height: 3, borderRadius: 2,
                                        bgcolor: 'background.input', overflow: 'hidden'}}>
                                        <Box sx={{height: '100%', borderRadius: 2, width: `${Math.abs(Number(item[metric]) || 0) / maximum * 100}%`,
                                            bgcolor: theme => alpha(Number(item[metric]) < 0 ? theme.palette.error.main : theme.palette.primary.main, 0.65)}}/>
                                    </Box>
                                </Box>
                                <Typography sx={{fontSize: 13, fontWeight: 600, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap',
                                    color: Number(item[metric]) < 0 ? 'error.main' : 'text.primary'}}>
                                    {formatMetric(item[metric], selectedMetric, currencyCode)}
                                </Typography>
                            </ListItem>
                        ))}
                    </List>}
        </DashboardPaper>
    );
}
